import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react'
import ProjectSidebar from './ProjectSidebar.js'
import ProjectVscEditor from './ProjectVscEditor.js'

const ProjectComponent = forwardRef(({ containerStatus: containerStatusProp, setContainerStatus: setContainerStatusProp, isReadOnly = false, ...props }, ref) => {
  const [internalContainerStatus, setInternalContainerStatus] = useState(() => {
    try {
      const stored = sessionStorage.getItem('projectCoding_containerStatus');
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      return null;
    }
  });

  const containerStatus = containerStatusProp !== undefined ? containerStatusProp : internalContainerStatus;
  const setContainerStatus = setContainerStatusProp || setInternalContainerStatus;

  const [validationResults, setValidationResults] = useState(null);

  useEffect(() => {
    if (containerStatusProp !== undefined) return;
    if (containerStatus) {
      try {
        sessionStorage.setItem('projectCoding_containerStatus', JSON.stringify(containerStatus));
      } catch (error) {}
    } else {
      try {
        sessionStorage.removeItem('projectCoding_containerStatus');
      } catch (error) {}
    }
  }, [containerStatus, containerStatusProp]);

  const handleSetContainerStatus = (status) => {
    setContainerStatus(status);
  };
  
  const sidebarRef = React.useRef(null);
  const pollingRef = React.useRef(null);
  const onEditorReadyRef = React.useRef(null);
  useImperativeHandle(ref, () => ({
    handleSave: async () => {
      if (sidebarRef.current) {
        return await sidebarRef.current.handleSave();
      }
    },
    validateSaveFields: () => {
      if (sidebarRef.current?.validateSaveFields) {
        return sidebarRef.current.validateSaveFields();
      }
      return false;
    },
  }));

  return (
    <div style={{ display: 'flex', width: '100%', height: '100%', gap: '8px', overflow: 'hidden' }}>
        <div style={{ width: '30%', height: '100%', minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <ProjectSidebar 
            ref={sidebarRef}
            containerStatus={containerStatus}
            setContainerStatus={handleSetContainerStatus}
            validationResults={validationResults}
            pollingRef={pollingRef}
            onEditorReadyRef={onEditorReadyRef}
            isReadOnly={isReadOnly}
          />
        </div>
        <div style={{ width: '70%', height: '100%', overflow: 'hidden' }}>
          <ProjectVscEditor 
            containerStatus={containerStatus}
            setValidationResults={setValidationResults}
            pollingRef={pollingRef}
            onEditorReadyRef={onEditorReadyRef}
            isReadOnly={isReadOnly}
          />
        </div>
    </div>
  )
});

ProjectComponent.displayName = 'ProjectComponent';

export default ProjectComponent   